import FilterBar from './filterBar';
import PostList from './postList';
import { Component } from 'react';
import axios from 'axios';
import queryString from 'query-string';
import { setQueryStringWithoutPageReload } from './queryString';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './App.css';

class App extends Component {
	constructor(props) {
		super(props);
		const initialFilter = queryString.parse(window.location.search, {arrayFormat: 'comma'});
		if ( initialFilter.filterTopics && initialFilter.filterTopics.constructor !== Array ) {
			initialFilter.filterTopics = [initialFilter.filterTopics];
		}
		if ( initialFilter.filterDocumentTypes && initialFilter.filterDocumentTypes.constructor !== Array ) {
			initialFilter.filterDocumentTypes = [initialFilter.filterDocumentTypes];
		}
		if ( initialFilter.filterLanguages && initialFilter.filterLanguages.constructor !== Array ) {
			initialFilter.filterLanguages = [initialFilter.filterLanguages];
		}
		if ( initialFilter.filterCompulsory === 'true' ) {
			initialFilter.filterCompulsory = true;
		} else if ( initialFilter.filterCompulsory === 'false' ) {
			initialFilter.filterCompulsory = false;
		}

		this.state = {
			postList: [],
			filteredPostList: [],
			topicCategories: [],
			documentTypes: [],
			languages: [],
			filterTopics: initialFilter.filterTopics ?? [],
			filterDocumentTypes: initialFilter.filterDocumentTypes ?? [],
			filterLanguages: initialFilter.filterLanguages ?? [],
			filterCompulsory: initialFilter.filterCompulsory,
		}
		this.setFilterTopics = this.setFilterTopics.bind(this);
		this.setFilterDocumentTypes = this.setFilterDocumentTypes.bind(this);
		this.setFilterLanguages = this.setFilterLanguages.bind(this);
		this.setFilterCompulsory = this.setFilterCompulsory.bind(this);
		this.getFilteredPostCount = this.getFilteredPostCount.bind(this);
		this.getFilteredPosts = this.getFilteredPosts.bind(this);
	}

	componentDidMount() {
		const endpoint = document.querySelector('link[rel="https://api.w.org/"]').href;

		axios({
			method: 'get',
			url: endpoint + 'wp/v2/employee_comms?per_page=100',
		}).then(posts => {
			let uniqueTopics = [];
			let uniqueTypes = [];
			let uniqueLanguages = [];

			// Get our topics
			posts.data.forEach((post) => {
				const topics = post.acf.topics;
				const documentType = post.acf.document_type;
				let altDownloads = post.acf.download_files ?? [];
				if ( altDownloads === false ) {
					altDownloads = [];
				}
				// Removed forEach since multi-selected is now disabled for Topics field.
				if ( ! uniqueTopics.includes(topics) ) {
					uniqueTopics.push(topics);
				}
				if ( ! uniqueTypes.includes(documentType) ) {
					uniqueTypes.push(documentType);
				}
				altDownloads.forEach(download => {
					if ( ! uniqueLanguages.includes( download.language ) ) {
						uniqueLanguages.push(download.language);
					}
				});
			});
			uniqueTopics.sort();
			uniqueTypes.sort();
			uniqueLanguages.sort();
			this.setState({
				postList: posts.data,
				topicCategories: uniqueTopics,
				documentTypes: uniqueTypes,
				languages: uniqueLanguages,
			}, this.setFilteredPostList);
		});
	}

	// Filter posts by categories.
	getFilteredPosts(filterTopics, filterDocumentTypes, filterLanguages, filterCompulsory ) {
		let filteredPosts = [];
		// Really should be a better way of doing this
		const hasFilterTopics = filterTopics.length > 0;
		const hasFilterDocumentTypes = filterDocumentTypes.length > 0;
		const hasFilterLanguages = filterLanguages.length > 0;
		const hasFilterCompulsory = filterCompulsory === true;

		// Put posts in topics
		this.state.topicCategories.forEach((topic) => {
			let addItem = true;
			if ( hasFilterTopics ) {
				addItem = filterTopics.includes( topic );
			}
			if ( addItem ) {
				let data = this.state.postList.filter(post => {
					return post.acf.topics.includes(topic);
				});
				if ( hasFilterDocumentTypes ) {
					data = data.filter(post => {
						return filterDocumentTypes.includes(post.acf.document_type);
					});
				}
				if ( hasFilterLanguages ) {
					data = data.filter(post => {
						const altDownloads = post.acf.download_files ?? [];
						let hasDownload = false;
						altDownloads.forEach(download => {
							if ( filterLanguages.includes( download.language ) ) {
								hasDownload = true;
							}
						});
						return hasDownload;
					});
				}

				if ( hasFilterCompulsory ) {
					data = data.filter(post => {
						return post.acf.is_compulsory === true;
					});
				}
				if ( data.length > 0 ) {
					filteredPosts.push([topic, data]);
				}
			}
		});
		return filteredPosts;
	}

	setFilteredPostList() {
		const filteredPosts = this.getFilteredPosts(this.state.filterTopics, this.state.filterDocumentTypes, this.state.filterLanguages, this.state.filterCompulsory);
		this.setState({
			filteredPostList: filteredPosts,
		});
		// Set query string
		const qsValues = queryString.parse(window.location.search, {arrayFormat: 'comma'});
		qsValues.filterTopics = this.state.filterTopics;
		qsValues.filterDocumentTypes = this.state.filterDocumentTypes;
		qsValues.filterLanguages = this.state.filterLanguages;
		qsValues.filterCompulsory = this.state.filterCompulsory;
		const newQsValue = queryString.stringify(qsValues, {arrayFormat: 'comma'});
		setQueryStringWithoutPageReload(`?${newQsValue}`);
	}

	setFilterTopics(topics) {
		this.setState({
			filterTopics: topics,
		}, this.setFilteredPostList);
	}

	setFilterDocumentTypes( types ) {
		this.setState({
			filterDocumentTypes: types,
		}, this.setFilteredPostList);
	}

	setFilterLanguages( types ) {
		this.setState({
			filterLanguages: types,
		}, this.setFilteredPostList);
	}

	setFilterCompulsory( value ) {
		value = value === true;
		this.setState({
			filterCompulsory: value,
		}, this.setFilteredPostList);
	}

	getFilteredPostCount() {
		let count = 0;
		this.state.filteredPostList.forEach(function(section) {
			count = count + section[1].length;
		});
		return count;
	}

  	render() {
		return (
			<div className="App" id="employee-toolkit-page">
				<FilterBar
					topicCategories={this.state.topicCategories}
					documentTypes={this.state.documentTypes}
					languages={this.state.languages}
					filterTopics={this.state.filterTopics}
					filterDocumentTypes={this.state.filterDocumentTypes}
					filterLanguages={this.state.filterLanguages}
					filterCompulsory={this.state.filterCompulsory}
					filteredPostList={this.state.filteredPostList}
					allPostCount={this.state.postList.length}
					setFilterTopics={this.setFilterTopics}
					setFilterDocumentTypes={this.setFilterDocumentTypes}
					setFilterLanguages={this.setFilterLanguages}
					setFilterCompulsory={this.setFilterCompulsory}
					filteredPostCount={this.getFilteredPostCount}
					getFilteredPosts={this.getFilteredPosts}
				/>
				<PostList filteredPostList={this.state.filteredPostList} />
			</div>
		);
	}
}

export default App;
